import { Component, OnInit, Input } from '@angular/core';
import { Education } from '../../types/helpers/education.model';
import { AddEducationModalComponent } from '../add-education-modal/add-education-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProfileService } from './../../profile.service';
import { environment } from 'projects/mmb-web-app/src/environments/environment';

@Component({
  selector: 'mmb-web-app-user-education-info',
  templateUrl: './user-education-info.component.html',
  styleUrls: ['./user-education-info.component.scss']
})
export class UserEducationInfoComponent implements OnInit {

  @Input() educations: Education[];
  @Input() isEditMode: boolean;

  constructor(private modalService: NgbModal,
    private profileService: ProfileService) { }

  ngOnInit() { }

  /**
   * Create education modal
   */
  addEducation(educations) {
    const modalRef = this.modalService.open(AddEducationModalComponent, { centered: true });
    modalRef.componentInstance.addSuccess.subscribe((ev) => {
      modalRef.componentInstance.educations = educations;
      this.getProfile();
    });

    modalRef.componentInstance.closed.subscribe((ev) => {
      modalRef.close();
    });
  }

  onEditEducation(education) {
    if (this.isEditMode) {
      this.editEducation(education);
    }
  }

  /**
   * Create edit education modal
   */
  editEducation(educations) {
    const modalRef = this.modalService.open(AddEducationModalComponent, { centered: true });
    modalRef.componentInstance.educations = educations;
    modalRef.componentInstance.isEditMode = true;
    modalRef.componentInstance.addSuccess.subscribe((ev) => {
      this.getProfile();
    });
    modalRef.componentInstance.closed.subscribe((ev) => {
      modalRef.close();
    });
  }

  getProfile() {
    this.profileService.getUserProfile().subscribe((response) => {
      this.educations = response.education;
    });
  }

  getOrganisation(item): any {
    if (item && item.organisation) {
      if (item.organisation.logo) {
        return {
          logo: item.organisation.logo
        };
      }
      if (item.organisation.website_url) {
        return {
          websiteUrl: item.organisation.websiteUrl
        };
      }
      return {
        name: item.organisation.name
      };
    }

    // organisation_custom
    if (item && item.organisation_custom) {
      return {
        name: item.organisation_custom
      };
    }

    return {
      name: ''
    };
  }

  getOrgImageUrl(item) {
    if (item) {
      if (item.logo) {
        return item.logo;
      }
      if (item.avatar) {
        return item.avatar;
      }
      if (item.websiteUrl) {
        return `${environment.api.logoServer}/${item.websiteUrl}`;
      }
    }
  }
}
